import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiBusinessUnitViewProfileTabBase } from '@fi-app/business-unit/business-unit-view-dialog/fi-business-unit-view-tab-group/fi-business-unit-view-profile-tab-base';

@Component({
    selector: 'fi-business-unit-view-contact-tab',
    templateUrl: './fi-business-unit-view-contact-tab.component.html',
    styleUrls: ['./fi-business-unit-view-contact-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-view-contact-tab' },
    standalone: false,
})
export class FiBusinessUnitViewContactTabComponent extends FiBusinessUnitViewProfileTabBase {}
